import { render } from "./Studies.vue?vue&type=template&id=34ebaf5d&ts=true"
import script from "./Studies.ts?vue&type=script&lang=ts"
export * from "./Studies.ts?vue&type=script&lang=ts"

import "./Studies.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__